import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import NotificationBanner from '../../components/NotificationBanner';

const ClientOverview = ({ 
  trackings, repacks, invoices, alerts, availableTrackings, mailbox,
  notificationPermission, notificationsSupported, requestNotificationPermission,
  renderMyMailbox
}) => {
  const pendingAlerts = alerts.filter(a => a.status !== 'processed');

  return (
    <div className="space-y-6">
      <NotificationBanner 
        permission={notificationPermission}
        isSupported={notificationsSupported}
        onRequestPermission={requestNotificationPermission}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium text-gray-600">Paquetes</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{trackings.length}</div>
            <p className="text-xs text-gray-500 mt-1">Total en casillero</p>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium text-gray-600">Reempaques</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{repacks.length}</div>
            <p className="text-xs text-gray-500 mt-1">Solicitudes realizadas</p>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium text-gray-600">Facturas</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{invoices.filter(i => i.status === 'pending').length}</div>
            <p className="text-xs text-gray-500 mt-1">Pendientes de pago</p>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium text-gray-600">Alertas</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{pendingAlerts.length}</div>
            <p className="text-xs text-gray-500 mt-1">Pendientes</p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Resumen del Casillero</CardTitle>
          <CardDescription>Vista general de tu cuenta</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-sm">Paquetes disponibles para reempaque:</span>
              <span className="font-semibold">{availableTrackings.length}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm">Reempaques en proceso:</span>
              <span className="font-semibold">{repacks.filter(r => r.status === 'processing').length}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm">Facturas pendientes:</span>
              <span className="font-semibold text-orange-600">
                ${invoices.filter(i => i.status === 'pending').reduce((sum, inv) => sum + (inv.balance_due || inv.total || 0), 0).toFixed(2)}
              </span>
            </div>
          </div>
        </CardContent>
      </Card>

      {mailbox && renderMyMailbox()}
    </div>
  );
};

export default ClientOverview;
